// extracted by mini-css-extract-plugin
export default {"root":"styles_root__mvRlr","container":"styles_container__P102B","subContainer":"styles_subContainer__g5H7S","cardItem":"styles_cardItem__7eBXD"};